import PortalClienteService from "services/bases/PortalClienteService";
import * as HttpRequest from 'EstruturaAntiga/assets/httpRequest';

class FormulariosEntidadeService extends PortalClienteService{
    _configuracaoFormularioCache = null;

    async ListarCamposPortalCliente() {
        const formularioId = HttpRequest.userTenant().formId;
        return await this.get(`FormularioEntidades/ListarCamposPortalCliente?formularioEntidadeId=${formularioId}`);
    }
    async ObterLinkDownloadCsvCamposFormulario(separador, incluirDadosDeExemplo) {
        const formularioId = HttpRequest.userTenant().formId;
        return await this.get(`FormularioEntidades/ObterLinkDownloadCsvCamposFormulario?formularioEntidadeId=${formularioId}&separador=${separador}&incluirDadosDeExemplo=${incluirDadosDeExemplo}`);
    }
    async ListarCamposMapeadosNoPortal() {
        const formularioId = HttpRequest.userTenant().formId;
        return await this.get(`FormularioEntidades/ListarCamposMapeadosNoPortal?formularioEntidadeId=${formularioId}`);
    }
    async ObterConfiguracaoFormulario() {
        if (!this._configuracaoFormularioCache) {
            const formularioId = HttpRequest.userTenant().formId;
            this._configuracaoFormularioCache = this.get(`FormularioEntidades/ObterConfiguracaoFormulario?formularioEntidadeId=${formularioId}`)
                .catch(erro => {
                    this._configuracaoFormularioCache = null;
                    throw erro;
                });
        }
        return this._configuracaoFormularioCache;
    }
}

export default new FormulariosEntidadeService();